module.exports = __webpack_public_path__ + "img/Cara_Naranja.823d77dd.svg";